.contact-us-page {
  --content-max: 1500px;
  --container-pad: clamp(16px, 4vw, 48px);

  .page {
    width: 100%;
    min-height: 100%;
    background-color: #fff;
  }

  // ---------------------------------------------------------------------------
  // Hero (wood banner + headline; matches Home / About hero rhythm)
  // ---------------------------------------------------------------------------
  .contact-hero {
    position: relative;
    width: 100%;
    min-height: clamp(360px, 52vh, 480px);
    background: url(../../assets/images/pages-contactus-contact-hero.png) no-repeat;
    background-size: cover;
    background-position: center;
    overflow: hidden;
  }

  .contact-hero__overlay {
    position: absolute;
    inset: 0;
    background-color: rgba(22, 0, 4, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .contact-hero__content {
    width: min(92vw, var(--content-max));
    padding: 0 var(--container-pad);
    box-sizing: border-box;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .contact-hero__title {
    margin: 0;
    max-width: 20ch;
    color: #fff;
    font-size: clamp(32px, 5vw, 56px);
    font-family:
      Red Rose-Regular,
      serif;
    font-weight: normal;
    text-align: center;
    line-height: 1.05;
    letter-spacing: 0.02em;
  }

  // ---------------------------------------------------------------------------
  // Intro: heading + address / email
  // ---------------------------------------------------------------------------
  .contact-intro {
    width: 100%;
    max-width: var(--content-max);
    margin: 0 auto;
    padding: clamp(48px, 8vw, 120px) var(--container-pad) clamp(32px, 5vw, 64px);
    box-sizing: border-box;
    text-align: center;
  }

  .contact-intro__title {
    margin: 0;
    color: rgb(22, 0, 4);
    font-size: clamp(40px, 6vw, 80px);
    font-family:
      Red Rose-Regular,
      serif;
    font-weight: normal;
    text-transform: uppercase;
    line-height: 1;
    letter-spacing: 0.04em;
  }

  .contact-intro__details {
    margin: clamp(14px, 2vw, 24px) auto 0;
    max-width: min(40rem, 100%);
    display: flex;
    flex-direction: column;
    gap: clamp(8px, 1.5vw, 12px);
  }

  .contact-intro__line {
    margin: 0;
    color: rgb(80, 80, 80);
    font-size: clamp(16px, 2vw, 20px);
    font-family:
      PingFang SC-Regular,
      system-ui,
      sans-serif;
    font-weight: normal;
    line-height: 1.5;
  }

  .contact-intro__link {
    color: rgb(22, 0, 4);
    text-decoration: underline;
    text-underline-offset: 3px;

    &:hover {
      text-decoration-thickness: 2px;
    }

    &:focus-visible {
      outline: 2px solid rgb(196, 180, 157);
      outline-offset: 2px;
    }
  }

  // ---------------------------------------------------------------------------
  // Third-party form embed
  // ---------------------------------------------------------------------------
  .contact-form-embed {
    width: 100%;
    max-width: var(--content-max);
    margin: 0 auto;
    padding: 0 var(--container-pad) 0px;
    box-sizing: border-box;
  }

  .contact-form-embed__frame-wrap {
    position: relative;
    width: 100%;
    min-width: 0;
    border-radius: 0;
    overflow: hidden;
  }

  .contact-form-embed__iframe {
    position: relative;
    z-index: 0;
    display: block;
    width: 100%;
    max-width: 100%;
    min-height: 860px;
    // height: min(720px, 85vh);
    border: none;
    background: transparent;
  }

  // Corner patch only (full-width bar felt like it covered “half” the form). Cross-origin: cannot target `.powered.generic-branding`.
  .contact-form-embed__branding-mask {
    position: absolute;
    z-index: 1;
    right: 0;
    bottom: 0;
    left: auto;
    width: 100%;
    height: 70px;
    max-height: 84px;
    background: #fff;
    pointer-events: none;
  }

  @media (max-width: 767px) {
    .contact-hero {
      min-height: clamp(320px, 48vh, 420px);
    }
  }
}
